import * as R from 'ramda'
import { isNotEmpty, isNotNil } from './'

export const isNotEmptyOrNil = R.both(isNotEmpty, isNotNil)
